import React, { useState, useEffect, useContext } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import {
  FiSearch,
  FiUserPlus,
  FiMoreHorizontal,
} from "react-icons/fi";
import ConfirmationModal from "../components/update-users";
import AddUserModal from "../components/addEdit-user";
import CreatePrayerPartner from "../components/CreatePrayerPartner";
import { showErrorMessage } from "../helpers/useToast";
import "../styles/addEdit-user.css";
import { ProfileContext } from "../contexts/ProfileContext";




export default function DashboardUsers() {
    const { worker, organizationFirebaseId // Get Firebase ID from context
    } = useContext(ProfileContext);
    const { getAccessTokenSilently } = useAuth0();
    const [usersList, setUsersList] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showAgentModal, setShowAgentModal] = useState(false);
    const [editUser, setEditUser] = useState(null);
    const [AllowedUsers, setAllowedUsers] = useState(0);
    const [PlanType, setPlanType] = useState("");
    // const [TotalUsers, setTotalUsers] = useState(5);
    const [openMenu, setOpenMenu] = useState(null);
    const [modal, setModal] = useState({ open: false, type: "", user: null });
    const handleOpenAdd = () => {
        // If AllowedUsers is set (>0) and current users reached or exceeded, block opening
        // but admins (admin, super_admin, c_suite) are exempt from this limit
        const isAdminUser = (() => {
            if (!worker) return false;
            const allowed = ['admin','super_admin','c_suite'];
            const r = worker.role || worker.roles;
            if (!r) return false;
            if (Array.isArray(r)) return r.map(x=>String(x).toLowerCase()).some(x=>allowed.includes(x));
            const s = String(r).toLowerCase();
            if (allowed.includes(s)) return true;
            return s.split(',').map(x=>x.trim()).some(x=>allowed.includes(x));
        })();

        if (!isAdminUser && AllowedUsers > 0 && usersList.length >= AllowedUsers) {
            showErrorMessage(`Only ${AllowedUsers} user(s) allowed.`);
            return;
        }
        setShowAddModal(true);
    };
    const handleCloseAdd = () => setShowAddModal(false);
    const handleOpenAgent = () => {
        const isAdminUser = (() => {
            if (!worker) return false;
            const allowed = ['admin','super_admin','c_suite'];
            const r = worker.role || worker.roles;
            if (!r) return false;
            if (Array.isArray(r)) return r.map(x=>String(x).toLowerCase()).some(x=>allowed.includes(x));
            const s = String(r).toLowerCase();
            if (allowed.includes(s)) return true;
            return s.split(',').map(x=>x.trim()).some(x=>allowed.includes(x));
        })();

        if (!isAdminUser && AllowedUsers > 0 && usersList.length >= AllowedUsers) {
            showErrorMessage(`Only ${AllowedUsers} user(s) allowed.`);
            return;
        }
        setShowAgentModal(true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { loadUsers() }, [worker, organizationFirebaseId]);

    // Helper used in multiple places to detect admin-like roles
    const isAdminWorker = () => {
        if (!worker) return false;
        const allowed = ['admin','super_admin','c_suite'];
        const r = worker.role || worker.roles;
        if (!r) return false;
        if (Array.isArray(r)) return r.map(x=>String(x).toLowerCase()).some(x=>allowed.includes(x));
        const s = String(r).toLowerCase();
        if (allowed.includes(s)) return true;
        return s.split(',').map(x=>x.trim()).some(x=>allowed.includes(x));
    };
     

    const loadUsers = async function() {
        try {

            if (!worker || !organizationFirebaseId) return;

            const isAdminUser = () => {
                if (!worker) return false;
                const allowed = ['admin','super_admin','c_suite'];
                const r = worker.role || worker.roles;
                if (!r) return false;
                if (Array.isArray(r)) return r.map(x=>String(x).toLowerCase()).some(x=>allowed.includes(x));
                const s = String(r).toLowerCase();
                if (allowed.includes(s)) return true;
                return s.split(',').map(x=>x.trim()).some(x=>allowed.includes(x));
            };

            let url = `${process.env.REACT_APP_API_URL}/auth0/organization/users?email=${encodeURIComponent(worker.email)}&firebase_id=${encodeURIComponent(organizationFirebaseId)}`;
            if (isAdminUser()) {
                url = `${process.env.REACT_APP_API_URL}/auth0/organization/users/admin?email=${encodeURIComponent(worker.email)}&firebase_id=${encodeURIComponent(organizationFirebaseId)}`;
            }

            console.log("Fetching users from URL:", url);
            // acquire an access token for the backend API, fall back to static header
            let token = null;
            try { token = await getAccessTokenSilently(); } catch (e) { /* ignore */ }
            const options = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token ? `Bearer ${token}` : process.env.REACT_APP_API_AUTHORIZATION,
                    Accept: "application/json",
                },
            };

            const response = await fetch(url, options);
            if (!response.ok) {
                console.error("Failed to fetch Users List", response.status);
                return;
            }

            const data = await response.json();

            // Temporary debug removed

            const mappedUsers = (data.users || []).map((user, index) => ({
                id: index + 1,
                // Prefer multiple metadata keys for full name, then top-level name, then display_name, then email
                name: user.user_metadata?.fullName || user.user_metadata?.full_name || user.user_metadata?.fullname || user.name || user.display_name || user.email || "Unknown User",
                email: user.email || "",
                // Prefer metadata phone or phone_number then top-level
                phone: user.user_metadata?.phone || user.user_metadata?.phone_number || user.phone || "-",
                status: user.blocked ? "Inactive" : "Active",
                image: user.picture || user.profile || "",
                // keep raw metadata for later UI decisions
                user_metadata: user.user_metadata || {},
            }));

            setUsersList(mappedUsers);
            setAllowedUsers(data.max_users || 0);
            setPlanType(data.organization?.tier_id || "");
        } catch (error) {
            console.error("Failed to load users:", error);
        }
    };

    const handleSaveUser = async (formData, mode = "add") => {
    if (mode === "edit" && formData.id !== undefined) {
      try {
        const original = usersList.find((u) => u.id === formData.id);
        const originalEmail = original?.email;

        // Prepare request body for PUT
        const body = {
          email: originalEmail || formData.email,
          full_name: formData.fullName || original?.name,
          display_name: formData.fullName || original?.name,
        };

        // include new_email if changed
        if (formData.email && originalEmail && formData.email !== originalEmail) {
          body.new_email = formData.email;
        }

        // include phone if present
        if (formData.phone) {
          body.phone = formData.phone;
        }

        const isAdminUserForReq = (() => {
            if (!worker) return false;
            const allowed = ['admin','super_admin','c_suite'];
            const r = worker.role || worker.roles;
            if (!r) return false;
            if (Array.isArray(r)) return r.map(x=>String(x).toLowerCase()).some(x=>allowed.includes(x));
            const s = String(r).toLowerCase();
            if (allowed.includes(s)) return true;
            return s.split(',').map(x=>x.trim()).some(x=>allowed.includes(x));
        })();

        let resp;
        if (isAdminUserForReq) {
            const url = `${process.env.REACT_APP_API_URL}/auth0/organization/user/admin/update`;
            const payload = {
                email: worker.email,
                firebase_id: organizationFirebaseId,
                target_email: originalEmail || formData.email,
                full_name: formData.fullName || original?.name,
                display_name: formData.fullName || original?.name,
            };
            if (formData.phone) payload.phone = formData.phone;
            if (formData.email && originalEmail && formData.email !== originalEmail) payload.new_email = formData.email;

            let token = null;
            try { token = await getAccessTokenSilently(); } catch (e) { /* ignore */ }
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token ? `Bearer ${token}` : process.env.REACT_APP_API_AUTHORIZATION,
                    Accept: 'application/json',
                },
                body: JSON.stringify(payload),
            };
            resp = await fetch(url, options);
        } else {
            const url = `${process.env.REACT_APP_API_URL}/auth0/user`;
            let token = null;
            try { token = await getAccessTokenSilently(); } catch (e) { /* ignore */ }
            const options = {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                Authorization: token ? `Bearer ${token}` : process.env.REACT_APP_API_AUTHORIZATION,
                Accept: 'application/json',
              },
              body: JSON.stringify(body),
            };
            resp = await fetch(url, options);
        }
        if (!resp.ok) {
          const errorData = await resp.json().catch(() => ({}));
          const message = errorData.error || `Failed to update user (${resp.status})`;
          console.error(message);
          showErrorMessage(message);
        } else {
          await resp.json().catch(() => ({}));

          // Update local list with returned or submitted values
          setUsersList((prev) =>
            prev.map((u) =>
              u.id === formData.id
                ? {
                    ...u,
                    name: body.full_name || u.name,
                    email: body.new_email || u.email,
                    phone: formData.phone || u.phone,
                    // keep status unchanged
                  }
                : u
            )
          );
        }
      } catch (err) {
        console.error('Error updating user:', err);
      } finally {
        setEditUser(null);
      }

      return;
    }

    // ADD user via API
    try {
        const url = `${process.env.REACT_APP_API_URL}/auth0/user`;
        const body = {
            email: formData.email,
            phone: formData.phone,
                full_name: formData.fullName,
                display_name: formData.fullName ? formData.fullName.split(' ')[0] : formData.email,
            // include password only if provided by the form (modal currently doesn't provide one)
            password: "Password123!",
                // ...(formData.password ? { password: formData.password } : {}),
                firebase_id: organizationFirebaseId,
      };

      let addToken = null;
      try { addToken = await getAccessTokenSilently(); } catch (e) { /* ignore */ }
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: addToken ? `Bearer ${addToken}` : process.env.REACT_APP_API_AUTHORIZATION,
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      };

      const resp = await fetch(url, options);
      if (!resp.ok) {
        console.error('Failed to add user', resp.status);
      } else {
        let respJson = {};
        try { respJson = await resp.json(); } catch (e) { }

        // Use returned user if available, otherwise fallback to local data
        const created = respJson.user || respJson || {};

        const nextId = usersList.length ? Math.max(...usersList.map((u) => u.id)) + 1 : 1;
        const initials = formData.fullName
          ? formData.fullName
              .split(" ")
              .map((n) => n[0] || "")
              .join("")
              .toUpperCase()
          : "";

        const newUser = {
          id: nextId,
          initials,
          name: created.full_name || created.name || formData.fullName || '',
          email: created.email || formData.email || '',
          phone: created.phone || formData.phone || '',
          status: created.blocked === true ? 'Inactive' : (created.status || (formData.status === 'ACTIVE' ? 'Active' : 'Inactive')),
        };

        setUsersList((prev) => [newUser, ...prev]);
      }
    } catch (err) {
      console.error('Error adding user:', err);
    }

    };

    const [searchTerm, setSearchTerm] = useState("");
    const [activeTab, setActiveTab] = useState('dashboard');
    const PAGE_SIZE = 10;
    const [pageDashboard, setPageDashboard] = useState(1);
    const [pageAgents, setPageAgents] = useState(1);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    // Helper to test search match
    const matchesSearch = (user) => {
        const q = searchTerm.trim().toLowerCase();
        if (!q) return true;
        const name = (user.name || "").toLowerCase();
        const email = (user.email || "").toLowerCase();
        const organizationName = (user.user_metadata.organizationName || user.user_metadata.organization_name || "").toLowerCase();
        return name.includes(q) || email.includes(q) || organizationName.includes(q);
    };

    // Separate users into dashboard and agents according to metadata rules
    const separateUsers = (list) => {
        const dashboard = [];
        const agents = [];
        list.forEach((u) => {
            // combine metadata and top-level possible fields to be robust
            const meta = u.user_metadata || {};
            const combined = Object.assign({}, meta);
            // also copy common top-level keys if present
            if (u.organizationName) combined.organizationName = u.organizationName;
            if (u.organization_name) combined.organization_name = u.organization_name;
            if (u.organization) combined.organization = u.organization;
            if (u.department) combined.department = u.department;

            // normalize keys to lowercase for robust detection
            const norm = {};
            Object.keys(combined).forEach((k) => { try { norm[String(k).toLowerCase()] = combined[k]; } catch (e) { /* ignore */ } });

            const deptKeys = ['department', 'dept', 'departmentname', 'department_name'];
            const orgKeys = ['organizationname', 'organization_name', 'organization', 'organisationname', 'organisation_name'];

            const hasDept = deptKeys.some(k => {
                const v = norm[k];
                return v !== undefined && v !== null && String(v).trim() !== '';
            });
            const hasOrg = orgKeys.some(k => {
                const v = norm[k];
                return v !== undefined && v !== null && String(v).trim() !== '';
            });

            // detect agent role in metadata (roles or role)
            const roleVal = (norm['roles'] ?? norm['role'] ?? '');
            const isAgentRole = (() => {
                if (!roleVal) return false;
                if (Array.isArray(roleVal)) return roleVal.map(x => String(x).toLowerCase()).some(r => r === 'agent');
                const s = String(roleVal).toLowerCase();
                return s === 'agent' || s.split(',').map(x => x.trim()).some(x => x === 'agent');
            })();

            // Debug logging for metadata classification (remove in production)
            try {
                // eslint-disable-next-line no-console
                console.debug('classify-user', { email: u.email, norm, hasDept, hasOrg });
            } catch (e) {}

            // Apply your precedence rules:
            // - If both department and organizationName -> Dashboard
            // - If has department only -> Agents
            // - If no department but has organizationName -> Dashboard
            // If role indicates agent, put into Agents (override other rules)
            if (isAgentRole) {
                if (matchesSearch(u)) agents.push(u);
                return;
            }

            if (hasDept && !hasOrg) {
                if (matchesSearch(u)) agents.push(u);
                return;
            }
            // All other cases -> Dashboard
            if (matchesSearch(u)) dashboard.push(u);
        });
        return { dashboard, agents };
    };

    const { dashboard: dashboardUsers, agents: agentsUsers } = separateUsers(usersList);

    // Pagination helpers
    const totalPages = (list) => Math.max(1, Math.ceil(list.length / PAGE_SIZE));
    const pageSlice = (list, page) => list.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

    const visibleDashboard = pageSlice(dashboardUsers, pageDashboard);
    const visibleAgents = pageSlice(agentsUsers, pageAgents);
    const visibleUsers = activeTab === 'agents' ? visibleAgents : visibleDashboard;
    const totalCount = activeTab === 'agents' ? agentsUsers.length : dashboardUsers.length;
    const currentPage = activeTab === 'agents' ? pageAgents : pageDashboard;
    const totalPagesCount = activeTab === 'agents' ? totalPages(agentsUsers) : totalPages(dashboardUsers);

    // Reset pagination when search or lists change
    React.useEffect(() => { setPageDashboard(1); setPageAgents(1); }, [searchTerm, usersList]);



    const handleEdit = (user) => {
        setEditUser(user);
        setShowAddModal(true);
        setOpenMenu(null);
    };

   
    const handleRemove = (user) => {
        console.log("Remove", user);
        setModal({
            open: true,
            type: "remove",
            user,
        });
        setOpenMenu(null);
    };
    
  return (
    <div className="min-h-screen bg-[#F7F8F8] p-6" onClick={() => setOpenMenu(null)}>
      {/* Header */}
      <div className="flex items-start justify-between mb-12">
        <div>
          <h1 className="text-3xl text-[#0B3D46]">
            {activeTab === 'agents' ? 'Agents (Twilio)' : 'DashBoard Users'}
          </h1>
          <p className="text-[#19A6C0] mt-2 text-lg">
            {activeTab === 'agents'
              ? 'Manage Twilio agents'
              : 'See who has access to your dashboard'}
          </p>
        </div>
        <div>
          {/* Tabs: only show for admin-like users */}
          {isAdminWorker() && (
            <div className="flex gap-2 items-center">
              <button onClick={() => setActiveTab('dashboard')} className={`px-4 py-2 rounded-2xl ${activeTab==='dashboard' ? 'bg-[#ff7b32] text-white' : 'bg-gray-100 text-[#197C8C]'}`}>
                Dashboard Users
              </button>
              <button onClick={() => setActiveTab('agents')} className={`px-4 py-2 rounded-2xl ${activeTab==='agents' ? 'bg-[#ff7b32] text-white' : 'bg-gray-100 text-[#197C8C]'}`}>
                Agents
              </button>
            </div>
          )}

          {/* Plan Card: hidden for admin/super_admin/c_suite users */}
          {!isAdminWorker() && (
            <div className="bg-[#ECE8F7] rounded-3xl px-4 py-2 flex items-center gap-4 border-[#D6CFF1] mt-4">
              <div>
                <h3 className="uppercase tracking-[3px] text-[#6A5BD2] font-semibold text-sm">
                  {PlanType} Plan
                </h3>
                <p className="text-gray-400 text-xl mt-1">{usersList.length} / {AllowedUsers} users</p>
              </div>

              <div className="relative w-16 h-16">
                <svg className="w-16 h-16 rotate-[-90deg]">
                  <circle
                    cx="32"
                    cy="32"
                    r="24"
                    fill="none"
                    stroke="#D5D0EE"
                    strokeWidth="8"
                  />
                  <circle
                    cx="32"
                    cy="32"
                    r="24"
                    fill="none"
                    stroke="#6A5BD2"
                    strokeWidth="8"
                    strokeDasharray="151"
                    strokeDashoffset={151 - (151 * usersList.length) / Math.max(AllowedUsers, 1)}
                  />
                </svg>

                <div className="absolute inset-0 flex items-center justify-center text-[#6A5BD2] font-semibold mt-1">
                  {usersList.length}/{AllowedUsers}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Main Card */}
      <div className="bg-white border-[#CBE3E7] rounded-3xl overflow-hidden">
        {/* Search */}
        <div className="p-4 flex gap-4">
          <div className="flex-1 relative">
            <FiSearch
              className="absolute left-5 top-1/2 -translate-y-1/2 text-gray-400 "
              size={20}
            />

            <input
              type="text"
              placeholder="Search here..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="border w-80 h-14 rounded-2xl border-[#26B5C8] pl-14 pr-4 outline-none"
            />
          </div>

                  {activeTab === 'dashboard' && (
                    <button onClick={handleOpenAdd} className="px-8 h-14 bg-[#FF7B32] rounded-2xl text-white flex items-center gap-3">
                      Add New User
                      <FiUserPlus size={20} />
                    </button>
                  )}
                  {activeTab === 'agents' && (
                    <button onClick={handleOpenAgent} className="px-8 h-14 bg-[#FF7B32] rounded-2xl text-white flex items-center gap-3">
                      Add New Agent
                      <FiUserPlus size={20} />
                    </button>
                  )}
        </div>

        {/* Table Header */}
              <div className={`${activeTab === "dashboard" ? "grid grid-cols-5" : "grid grid-cols-4"} border-[#CBE3E7] bg-[#FAFCFC] py-3 px-8 text-[#16899A] font-semibold tracking-[3px] text-center`} style={{ gridTemplateColumns: '2fr 2fr 1.5fr 1fr 100px' }}>
          <div className="#">User Name</div>
          <div className="#">Email</div>
                  {activeTab === 'dashboard' ? (<div className="#">Organization</div>) :
                (<div className="#">Role</div>)}
                  {activeTab === "dashboard" ? (<div className="#">Status</div>) : (<div className="#">Organization</div>)}
            {activeTab !== 'agents' && (<div>Actions</div>)}
        </div>

        {/* Rows */}
        {visibleUsers.map((user) => (
          <div
            key={user.id}
            className={`${activeTab === "dashboard" ? "grid grid-cols-5" : "grid grid-cols-4"} items-center px-6 py-1 border-t border-[#CBE3E7] h-[56px]`}
            style={{ minHeight: 0, gridTemplateColumns: '2fr 2fr 1.5fr 1fr 100px' }}
          >
            {/* User */}
            <div className="flex items-center gap-4">
                {user.image ? (
                    <img
                        src={user.image}
                        alt={user.name}
                        className="w-9 h-9 rounded-full bg-[#1B91A3] flex items-center justify-center text-white font-bold">
                        
                    </img>
                ) : (
                    <div className="w-9 h-9 rounded-full bg-[#1B91A3] flex items-center justify-center text-white font-bold">
                        {user.name.substring(0, 2).toUpperCase()}
                    </div>
                )}

                <span className="text-[#16899A] text-lg font-medium">
                    {user.name}
                </span>
            </div>

            {/* Email */}
            <div className="text-[#16899A] text-lg text-base pl-4 text-center">
              {user.email}
            </div>

            {/* Organization */}
            <div className="text-[#16899A] text-lg  text-center">
                    {activeTab === 'dashboard' ? (user.user_metadata.organizationName ? user.user_metadata.organizationName : user.user_metadata.organization_name) : (user.user_metadata.role ? user.user_metadata.role : user.user_metadata.roles)}
            </div>

            {/* Status */}
            <div className="text-[#16899A] text-lg text-center">
                    {activeTab === 'dashboard' ? (           
                            user.status === "Active" ? (
                                <span className="inline-flex items-center gap-2 bg-[#DFE9CB] text-[#45BB3B] px-6 py-2 rounded-full uppercase text-xs tracking-[3px] font-semibold">
                                    <span className="w-2 h-2 bg-[#45BB3B] rounded-full"></span>
                                    Active
                                </span>
                            ) : (
                                <span className="inline-flex items-center gap-2 bg-[#E4E4E4] text-[#888888] px-6 py-2 rounded-full uppercase text-xs tracking-[3px] font-semibold">
                                    <span className="w-2 h-2 bg-[#888888] rounded-full"></span>
                                    Inactive
                                </span>
                            )
                        ) : (user.user_metadata.organizationName ? user.user_metadata.organizationName : user.user_metadata.organization_name)
                    }
                </div>

            
                {/* Actions  */}

                {activeTab === 'dashboard' && (
                    <div className="flex justify-end relative w-[50%]">
                        <button
                            type="button"
                            className="text-[#FF7B32]"
                            onClick={(e) => {
                                e.stopPropagation();
                                setOpenMenu(openMenu === user.id ? null : user.id);
                            }}
                        >
                            <FiMoreHorizontal size={26} />
                        </button>

                        {openMenu === user.id && (
                            <div onClick={(e) => e.stopPropagation()} className="absolute right-0 top-8 z-50 w-48 bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
                                <button
                                    onClick={() => handleEdit(user)}
                                    className="block w-full text-left px-4 py-2 hover:bg-gray-50 text-[#197C8C]"
                                >
                                    Edit User
                                </button>

                                <button
                                    onClick={() => {
                                        setModal({ open: true, type: user.status === 'Active' ? 'deactivate' : 'activate', user });
                                        setOpenMenu(null);
                                    }}
                                    className="block w-full text-left px-4 py-2 hover:bg-gray-50 text-[#197C8C]"
                                >
                                    {user.status === 'Active' ? 'Deactivate User' : 'Reactivate User'}
                                </button>

                                <button
                                    onClick={() => handleRemove(user)}
                                    className="block w-full text-left px-4 py-2 hover:bg-red-50 text-red-600"
                                >
                                    Remove User
                                </button>
                            </div>
                        )}
                    </div>)
            
            }
          </div>
        ))}

        {/* Footer */}
        <div className="border-t border-[#CBE3E7] px-6 py-6 text-gray-500 text-lg">
          Showing {Math.min(currentPage * PAGE_SIZE, totalCount)} of {totalCount} users
          <div className="float-right flex items-center gap-2">
            <button
              disabled={currentPage <= 1}
              onClick={() => {
                if (activeTab === 'agents') setPageAgents((p) => Math.max(1, p - 1));
                else setPageDashboard((p) => Math.max(1, p - 1));
              }}
              className="px-3 py-2 bg-gray-100 rounded"
            >Prev</button>
            <span className="px-3">{currentPage} / {totalPagesCount}</span>
            <button
              disabled={currentPage >= totalPagesCount}
              onClick={() => {
                if (activeTab === 'agents') setPageAgents((p) => Math.min(totalPagesCount, p + 1));
                else setPageDashboard((p) => Math.min(totalPagesCount, p + 1));
              }}
              className="px-3 py-2 bg-gray-100 rounded"
            >Next</button>
          </div>
        </div>
      </div>
      <AddUserModal
        show={showAddModal}
        handleClose={() => { handleCloseAdd(); setEditUser(null); }}
        handleSave={handleSaveUser}
        mode={editUser ? "edit" : "add"}
        user={editUser}
        maxUsers={AllowedUsers}
        currentUsersCount={usersList.length}
          />
      <CreatePrayerPartner
        showLock={showAgentModal}
        setShowLock={setShowAgentModal}
        onSuccess={loadUsers}
      />
      <ConfirmationModal
        open={modal.open}
        type={modal.type}
        user={modal.user}
        onClose={() =>
            setModal({
                open: false,
                type: "",
                user: null,
            })
        }
        onConfirm={async (data) => {
            console.log(data);

            try {
                if (data.action === "deactivate" || data.action === "activate") {
                    const userToUpdate = modal.user;
                    const emailToUpdate = userToUpdate?.email;

                    if (!emailToUpdate) {
                        console.error('No email available for user to update status');
                    } else {
                        const action = data.action === 'deactivate' ? 'deactivate' : 'activate';
                        const isAdminUserForReq = (() => {
                            if (!worker) return false;
                            const allowed = ['admin','super_admin','c_suite'];
                            const r = worker.role || worker.roles;
                            if (!r) return false;
                            if (Array.isArray(r)) return r.map(x=>String(x).toLowerCase()).some(x=>allowed.includes(x));
                            const s = String(r).toLowerCase();
                            if (allowed.includes(s)) return true;
                            return s.split(',').map(x=>x.trim()).some(x=>allowed.includes(x));
                        })();
                        const url = isAdminUserForReq
                            ? `${process.env.REACT_APP_API_URL}/auth0/organization/user/admin/${action}`
                            : `${process.env.REACT_APP_API_URL}/auth0/user/${action}`;
                        console.log(`Sending ${action} request for user:`, emailToUpdate);
                        let tokenPost = null;
                        try { tokenPost = await getAccessTokenSilently(); } catch (e) { /* ignore */ }
                        const body = isAdminUserForReq
                            ? { email: worker.email, firebase_id: organizationFirebaseId, target_email: emailToUpdate }
                            : { email: emailToUpdate };
                        const options = {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: tokenPost ? `Bearer ${tokenPost}` : process.env.REACT_APP_API_AUTHORIZATION,
                                Accept: 'application/json',
                            },
                            body: JSON.stringify(body),
                        };

                        const resp = await fetch(url, options);
                        if (!resp.ok) {
                          const errorData = await resp.json().catch(() => ({}));
                          const message = errorData.error || `Failed to ${action} user (${resp.status})`;
                          console.error(message);
                          showErrorMessage(message);
                        } else {
                            // update local list status
                            setUsersList((prev) =>
                                prev.map((u) =>
                                    u.email === emailToUpdate
                                        ? { ...u, status: action === 'deactivate' ? 'Inactive' : 'Active' }
                                        : u
                                )
                            );
                        }
                            await loadUsers();
                    }
                }

                if (data.action === "remove") {
                    const userToRemove = modal.user;
                    const email = userToRemove?.email;

                    if (!email) {
                        console.error('No email available for user to remove');
                    } else {
                        const url = `${process.env.REACT_APP_API_URL}/auth0/user`;
                        let tokenDel = null;
                        try { tokenDel = await getAccessTokenSilently(); } catch (e) { /* ignore */ }
                        const options = {
                            method: 'DELETE',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: tokenDel ? `Bearer ${tokenDel}` : process.env.REACT_APP_API_AUTHORIZATION,
                                Accept: 'application/json',
                            },
                            body: JSON.stringify({ email }),
                        };

                        const response = await fetch(url, options);
                        if (!response.ok) {
                            console.error('Failed to delete user', response.status);
                        } else {
                            const resp = await response.json();
                            if (resp && resp.status === 'removed') {
                                // remove from list
                                setUsersList((prev) => prev.filter((u) => u.email !== email));
                                console.log('User deleted successfully', resp);
                            } else {
                                console.error('Unexpected delete response', resp);
                            }
                        }
                    }
                }
            } catch (err) {
                console.error('Error in onConfirm:', err);
            } finally {
                setModal({ open: false, type: '', user: null });
            }
        }}
      />
    </div>
  );
}
